(function () {
  'use strict';
  class Controller {
    constructor($window) {
      this.history = $window.history;
    }
    $back() {
      this.history.back();
    }
  }
  angular
    .module('site.update', [])
    .component('siteUpdate', {
      controller: Controller,
      templateUrl: 'root/site/update/update-site.route.html'
    })
    .config(function ($stateProvider) {
      $stateProvider
        .state('site.update', {
          abstract: false,
          url: '/update?approval&productId',
          template: '<site-update/>'
        });
    });
}());
